import { $t } from '@/i18n';
// import pageLoader from '@loaders/page/loader';

export default {
  type: 'object',
  fields: [
    {
      id: 'pageletId',
      type: 'string',
      title: $t('k_35b9cacb'),
      ui: { type: 'XyInnerPageSelector' },
      default: '',
    },
    {
      id: 'params',
      type: 'array',
      title: $t('k_ac6619e7'),
      ui: {
        type: 'XyPageletPropsEditor',
        props: {
          allowBind: true,
          async getPagelet(inputBox) {
            const { pageletId } = inputBox.container.stub.parent.value;
            const pagelets = inputBox?.wContext?.config?.pageConfig ?? [];
            return pagelets.find(x => x.id === pageletId);
          },
        },
      },
      items: {
        type: 'object',
        fields: [
          { id: 'key', type: 'string' },
          { id: 'value', type: 'string' },
          { id: 'bind', type: 'string' },
        ],
      },
    },
  ],
};
